import { APP_PATH } from "constants/path";
import { RATING_APP, RATING_TYPE } from "./content/constant";
import { RatingContent } from "./content/types";

export const getRatingTypeText = (record: RatingContent) => {
	const ratingType =
		record.app === RATING_APP.CUSTOMER
			? RATING_TYPE.APP.label.customer
			: RATING_TYPE.APP.label.merchant;
	switch (record.ratingType) {
	case RATING_TYPE.APP.key:
		return ratingType;
	case RATING_TYPE.LIBERTY_SERVICES.key:
		return RATING_TYPE.LIBERTY_SERVICES.label;
	case RATING_TYPE.CAR.key:
		return RATING_TYPE.CAR.label;
	case RATING_TYPE.CAR_CARE_SERVICE.key:
	return RATING_TYPE.CAR_CARE_SERVICE.label;
	default:
		return record.ratingType;
	}
};

export const isPurchaseId = (id: string) : boolean => {
	const regexPattern = /^CP/;
	return regexPattern.test(id);
};

export const isBookingId = (id: string) : boolean => {
	const regexPattern = /^TD/;
	return regexPattern.test(id);
};

export const formatRatingsResponse = (items: any) : any => items.map((item: any) => {
	const ratingType = getRatingTypeText(item as RatingContent);
	let title ="";
	let path = "";
	if(ratingType === RATING_TYPE.APP.label.customer || ratingType === RATING_TYPE.APP.label.merchant) {
		title = ratingType;
	} else {
		if(isBookingId(item.sourceId)) {
			title = "Booking ID";
			path = `${APP_PATH.transactionAppointment}/${item.sourceId}`;
		} else {
			title = "Purchase ID";
			path = `${APP_PATH.transactionPurchase}/${item.sourceId}`;
		}

		if(item.ratingType === RATING_TYPE.CAR_CARE_SERVICE.key){
			title = "Booking ID";
			path = `${APP_PATH.transactionCarCare}/${item.sourceId}`;
		}

	}
	const tags = item?.ratingContents.map((rating: { content: string }) => rating.content) || [];
	const services = item?.ratingServices || [];

	return {
		ratingType,
		title,
		path,
		createdAt: item.createdAt,
		transactionId: item.sourceId,
		content: item.comment,
		stars: item.rate,
		tags,
		services,
		car: item.car,
		reviewer: item.reviewer,
		app: item.app,
		id: item.id,
		hidden: item.hidden,
		sourceId: item.sourceId
	};
});